<template>
  <div class="page">
    <a-card title="PC网站" :bodyStyle="{padding:'0px'}" :bordered="false"
            :headStyle="{borderBottom:'0px',fontSize:'18px'}">
      <a-card v-if="!isOpen" class="install-ly" title="您尚未开通PC网站" :bordered="false"
              :headStyle="{borderBottom:'0px',fontSize:'16px'}">
        <div>1、该功能暂时仅支持线下开通，如需使用请联系你的商务经理。</div>
      </a-card>
      <div v-else>
        <a-tabs v-model="activeKey">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.name">
          </a-tab-pane>
        </a-tabs>
        <SlideShowComponents v-if="activeKey === 1"></SlideShowComponents>
        <CooperativePartner v-if="activeKey === 2"></CooperativePartner>
        <FriendlyLink v-if="activeKey === 3"></FriendlyLink>
        <BasicInformation v-if="activeKey === 4"></BasicInformation>
        <SEOptimize v-if="activeKey === 5"></SEOptimize>
        <CompanyNews v-if="activeKey === 6"></CompanyNews>
        <JobVacancy v-if="activeKey === 7"></JobVacancy>
        <DevelopmentHistory v-if="activeKey === 8"></DevelopmentHistory>
        <OtherInformation v-if="activeKey === 9"></OtherInformation>
      </div>
    </a-card>
  </div>
</template>

<script>
import SlideShowComponents from '@/views/platform/manager/components/SlideShowComponents'
import CooperativePartner from '@/views/platform/manager/components/CooperativePartner'
import FriendlyLink from '@/views/platform/manager/components/FriendlyLink'
import BasicInformation from '@/views/platform/manager/components/BasicInformation'
import SEOptimize from '@/views/platform/manager/components/SEOptimize'
import CompanyNews from '@/views/platform/manager/components/CompanyNews'
import JobVacancy from '@/views/platform/manager/components/JobVacancy'
import DevelopmentHistory from '@/views/platform/manager/components/DevelopmentHistory'
import OtherInformation from '@/views/platform/manager/components/OtherInformation'
import moment from 'moment'

export default {
  name: 'PcWeb',
  components: {
    SlideShowComponents,
    CooperativePartner,
    FriendlyLink,
    BasicInformation,
    SEOptimize,
    CompanyNews,
    JobVacancy,
    DevelopmentHistory,
    OtherInformation
  },
  data() {
    return {
      isOpen: false,
      activeKey: 1,
      tabList: [
        {
          name: '轮播图',
          key: 1
        },
        {
          name: '合作伙伴',
          key: 2
        },
        {
          name: '友情链接',
          key: 3
        },
        {
          name: '基本信息',
          key: 4
        }, {
          name: 'SEO优化',
          key: 5
        },
        {
          name: '公司新闻',
          key: 6
        }, {
          name: '招聘职位',
          key: 7
        },
        {
          name: '发展历程',
          key: 8
        },
        {
          name: '其他信息',
          key: 9
        }
      ]
    }
  },
  mounted() {
    this.getOpenStatus()
  },
  methods: {
    getOpenStatus() {
      let url = 'pc/v2/circle-picture/isopen-mall'
      this.getHttpServices().getUserService().post(url)
        .then(res => {
          this.isOpen = !!res.openStatus
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    }
  }
}
</script>

<style lang="less">
@import url('../../CustomPage.less');

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}
</style>